import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPointV3 } from '@retailer-platform/dashboard/routing'
import { storeInterventionsAdminRouter } from './routing/storeInterventionsAdminRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import {
  storeInterventionsCreateNewRequestAccessControl,
  storeInterventionsViewAccessControl,
} from './access-control/storeInterventionsAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'store-interventions',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'store-interventions-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    admin: [storeInterventionsAdminRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [
    {
      attachToV3: AdminNavEntryPointV3.Fulfillment,
      subNavItems: [
        {
          route: 'app-admin-store-interventions-request-list',
          subRoutes: [
            'app-admin-store-interventions-duplicate-request',
            'app-admin-store-interventions-update-request',
          ],
          labelId: 'storeInterventionsDomain.navbar.requestList.label',
          labelIdV3: 'storeInterventionsDomain.navbar.requestList.label.v3',
          accessControl: storeInterventionsViewAccessControl,
          positionNavV3: 2,
        },
        {
          route: 'app-admin-store-interventions-create-request',
          subRoutes: ['app-admin-store-interventions-request-details'],
          labelId: 'storeInterventionsDomain.navbar.createRequest.label',
          labelIdV3: 'storeInterventionsDomain.navbar.createRequest.label.v3',
          accessControl: storeInterventionsCreateNewRequestAccessControl,
          positionNavV3: 1,
        },
      ],
    },
  ],
}

export default definition
